import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_pea" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_checkbox_field = _resolveComponent("checkbox-field")

  return (_openBlock(), _createBlock(_component_checkbox_field, _mergeProps({..._ctx.$attrs, ..._ctx.$props}, {
    condensed: true,
    "onUpdate:modelValue": $options.onInput
  }), {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString($options.checkboxVatPayerConfirmationMessage) + "  ", 1 /* TEXT */),
      _createVNode(_component_tooltip, {
        text: $options.checkboxVatPayerConfirmationTooltipText,
        position: "right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("em", _hoisted_1, [
            _createVNode(_component_base_icon, { name: "circle-info" })
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["text"])
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["onUpdate:modelValue"]))
}